import { Test } from './Test';
import { Source } from './Source';
export class TestRequest {
  Id: string;
  LabNumber: string;
  HospitalNo: string;
  Reference: string;
  Sex: string;
  RequestDate: Date;
  Title: string;
  Dob: Date;
  AttendingDr: string;
  AccountTo: string;
  IsGrey: boolean;
  IsFasting: boolean;
  NeedsKit: boolean;
  NeedsVenous: boolean;
  ForeName: string;
  Surname: string;
  Email: string;
  Phone: string;
  SampleDate: Date;
  Address1: string;
  Address2: string;
  Address3: string;
  PostCode: string;
  InsuranceNum: string;
  InsuranceCo: string;
  ClinDets: string;
  Tests: Test[];
  Source: Source;
  Clinician: string
}
